export class SendViaApiParameter {
  public Name: string;
  public Value: string;
  
  constructor(init: any) {
    this.Name = init.Name;
    this.Value = init.Value;    
  }
}